import { PropsWithChildren } from "react";

import { PopoverContext } from "./context";
import { usePopover } from "./hooks";
import { PopoverOptions } from "./types";

export function PopoverRoot({ children, ...restOptions }: PropsWithChildren<PopoverOptions>) {
  // This can accept any props as options, e.g. `placement`,
  // or other positioning options.
  const popover = usePopover(restOptions);
  return <PopoverContext.Provider value={popover}>{children}</PopoverContext.Provider>;
}
